export const getDefaultCookieDomain = () =>
  location?.domain || location?.hostname || 'wetransfer.com';
